/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/13
 * Time: 10:56
 * Desc:首页
 */

import { Component, Vue } from 'vue-property-decorator';
import { IPSService } from '@/services/ipsServices';
import NoAuth from '@/views/components/noAuth/noAuth.vue';
import { CacheKeyType } from '@/library/cache/types';
import baseAPIService from '@/services/base/baseAPIService';
import { showPlatform } from '@/util';

@Component({
  components: {
    NoAuth,
  },
})
export default class HomePage extends Vue {
  /* 数据 */

  /**
   * 左侧菜单权限控制
   * @type {ItemObject}
   */
  public menuRightsList: Array<string> = [];

  /**
   * 菜单是否显示
   * @type {boolean}
   */
  public isElMenuShow = false;

  /**
   * 管理员名称
   * @type {string}
   */
  public adminName = '';

  /**
   * 列表是否展开
   * @type {boolean}
   */
  public isCollapse = false;

  /**
   * 无权限状态是否显示
   * @type {boolean}
   */
  public isNoAuthShow = false;

  showPlatform = showPlatform();

  isOpenVisitTrend = 0

  /* 计算属性 */
  get onRoutes() {
    let defaultRoute = '';
    switch (this.$route.path.split('/')[1]) {
      case 'siteManage': // 网点管理
        defaultRoute = '/siteManage';
        break;
      case 'virtualManager': // 顾客分销管理-虚拟店长管理
        defaultRoute = '/virtualManager';
        break;
      case 'tryOnBoard': // 报表中心
        defaultRoute = '/tryOnBoard';
        break;
      case 'distributeStrategySetting': // 分销策略设置
        defaultRoute = '/distributeStrategySetting';
        break;
      case 'activityTypeEdit': // 活动类型设置
        defaultRoute = '/activityTypeSetting';
        break;
      case 'appSetting': // 云店设置
        defaultRoute = '/appSetting';
        break;
      // case "vGuiderReport": // 顾客分销管理-虚拟店长管理
      //   defaultRoute = "/vGuiderReport";
      // break;
      case 'videoManage': // 直播管理
        defaultRoute = '/videoManage';
        break;
      default:
        defaultRoute = this.$route.path;
        break;
    }
    return defaultRoute;
  }

  /* 方法 */

  /**
   * 获取后台菜单列表
   * @return null
   */
  public getMenuRights(): void {
    const loading = this.$loading({
      lock: true,
      text: '请稍等',
      spinner: 'el-icon-loading',
      background: 'rgba(225, 225, 225, 0.3)',
    });
    IPSService.adminAuthMenuList({
      postParams: {
        platId: baseAPIService.resolvePlatId() || '',
      },
    }).then((res) => {
      localStorage.removeItem('authMenuCodeList'); // 清理权限
      this.adminName = res.authName ? res.authName : 'Admin';
      localStorage.setItem('empCode', res.empCode);
      localStorage.setItem('secureLevel', res.secureLevel);
      if (res.authMenuCodeList.constructor === Array && res.authMenuCodeList.length > 0) {
        this.menuRightsList = res.authMenuCodeList;
        this.menuRightsList.push('VSHOP-FUNCTION-ACTIVITY-OUT');
        // this.menuRightsList.push('VSHOP-FUNCTION-REPORT-TRYON','VSHOP-FUNCTION-REPORT');
        this.$store.commit('onModifyAuthMenuCodeList', this.menuRightsList);
        this.$store.commit('onModifyEmpCode', res.empCode);

        this.pageShow(); // 页面分发
        this.isNoAuthShow = this.menuRightsList.length === 0;
      } else {
        this.menuRightsList = [];
        this.isNoAuthShow = true;
      }
      loading.close();
    });
  }

  /**
   * 判断菜单权限
   * @param {string} name
   * @return {boolean}
   */
  public menuAuth(name: string): boolean {
    return this.menuRightsList.includes(name);
  }

  /**
   * 左侧列表打开和关闭
   * @return null
   */
  public onCollapseLeftMenu(): void {
    this.isCollapse = !this.isCollapse;
  }

  /**
   * 页面分发
   * @return null
   */
  public pageShow(): void {
    // 由于默认是网点管理，所以当此页面无权限，进入最近的一个页面
    if (this.menuRightsList.includes('VSHOP-FUNCTION-SITE')) {
      this.$router.push('/siteManage'); // 网点管理
    } else if (this.menuRightsList.includes('VSHOP-FUNCTION-QIKAN')) {
      this.$router.push('/periodicalManage'); // 期刊管理
    } else if (this.menuRightsList.includes('VSHOP-FUNCTION-ACTIVITY')) {
      if (this.menuRightsList.includes('VSHOP-FUNCTION-ACTIVITY-INNER')) {
        this.$router.push('/innerActivityManage'); // 活动管理
      }
    } else if (this.menuRightsList.includes('VSHOP-FUNCTION-DISTRIBUTE')) {
      // 顾客分销管理
      if (this.menuRightsList.includes('VSHOP-FUNCTION-DISTRIBUTE-CONFIRM')) {
        this.$router.push('/recruitConfirmManage'); // 报名审核管理
      } else if (this.menuRightsList.includes('VSHOP-FUNCTION-DISTRIBUTE-VIRGUIDER')) {
        this.$router.push('/virtualManager'); // 虚拟店长管理
      } else if (this.menuRightsList.includes('VSHOP-FUNCTION-DISTRIBUTE-GOODS')) {
        this.$router.push('/distributeManage'); // 分销商品管理
      } else if (this.menuRightsList.includes('VSHOP-FUNCTION-DISTRIBUTE-CASH')) {
        this.$router.push('/remitManage'); // 提现管理
      } else if (this.menuRightsList.includes('VSHOP-FUNCTION-DISTRIBUTE-DEPOSIT')) {
        this.$router.push('/depositManage'); // 押金管理
      }
    } else if (this.menuRightsList.includes('VSHOP-FUNCTION-REPORT')) {
      if (this.menuRightsList.includes('VSHOP-FUNCTION-REPORT-TRYON')) {
        this.$router.push('/tryOnBoard'); // 试穿报表
      } else if (this.menuRightsList.includes('VSHOP-FUNCTION-REPORT-DISTRIBUTE')) {
        this.$router.push('/distributeBoard'); // 分销报表
      } else if (this.menuRightsList.includes('VSHOP-FUNCTION-REPORT-V-GUIDER')) {
        this.$router.push('/vGuiderReport'); // 虚拟店长统计
      } else if (this.isOpenVisitTrend) {
        this.$router.push('/appSumUpBoard'); // 小程序综合报表
      }
    } else if (this.menuRightsList.includes('VSHOP-FUNCTION-BASIC')) {
      if (this.menuRightsList.includes('VSHOP-FUNCTION-BASIC-STORE')) {
        this.$router.push('/appSetting'); // 云店设置
      } else if (this.menuRightsList.includes('VSHOP-FUNCTION-BASIC-ACTIVITY')) {
        this.$router.push('/activityTypeSetting'); // 活动类型设置
      } else if (this.menuRightsList.includes('VSHOP-FUNCTION-DISTRIBUTE-GOODS')) {
        this.$router.push('/tryOnAndExampleSetting'); // 试穿及出样设置
      } else if (this.menuRightsList.includes('VSHOP-FUNCTION-BASIC-DISTRIBUTE')) {
        this.$router.push('/distributeStrategySetting'); // 分销策略设置
      } else if (this.menuRightsList.includes('VSHOP-FUNCTION-BASIC-OTHERS')) {
        this.$router.push('/extended'); // 其他
      }
    }
    this.isElMenuShow = true;
  }

  /* 周期 */

  /**
   * 当组件加载时
   */
  public created() {
    localStorage.removeItem(CacheKeyType.CACHE_FOR_PORTAL_TOKEN);
    this.getMenuRights(); // 获取菜单权限
    this.isOpenVisitTrend = +localStorage.getItem('isOpenVisitTrend');
  }
  /**
   * 当组件加载完成
   */
  public mounted() {
    // 获取视窗口的高度，很多页面共用
    this.$store.commit('onSaveWindowHeight', window.innerHeight);
    window.onresize = () => {
      this.$store.commit('onSaveWindowHeight', window.innerHeight);
    };
    this.isElMenuShow = true;
  }
}
